import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { AppState } from '../AppState';
import { DetailContainer, DetailsContainer } from '../easyclaim.app.components/index';

import { ScreenComponent } from './ScreenComponent';

export class NecessaryDocuments extends ScreenComponent<AppState, {}> {
	public render() {
		const customerShortName = this.props.easyClaimCase?._configuration?.companyShortName
			?.toLocaleLowerCase()
			.trim();
		const registrationOuterExampleSrc =
			customerShortName === 'allianzpt'
				? '/images/example-registration-document-outer-pt.png'
				: '/images/example-registration-document-outer.png';

		const registrationInnerExampleSrc =
			customerShortName === 'allianzpt'
				? '/images/example-registration-document-inner-pt.jpeg'
				: '/images/example-registration-document-inner.png';

		return (
			<div className="main-container">
				<h2 className="necessary-documents-title">
					<FormattedMessage id="necessaryDocuments.headline.first" />
				</h2>
				<DetailsContainer>
					<DetailContainer>
						<Paragraph>
							<FormattedMessage id="necessaryDocuments.paragraph.first" />
						</Paragraph>
						<Paragraph>
							<h3>
								{'1. '}
								<FormattedMessage id="necessaryDocuments.registrationDocument.headline" />
							</h3>
							<FormattedMessage id="necessaryDocuments.registrationDocument.description"></FormattedMessage>
							<Image
								src={process.env.PUBLIC_URL + registrationOuterExampleSrc}
								paddingBottom="1rem"
							/>
							<FormattedMessage id="necessaryDocuments.registrationDocument.description_inner"></FormattedMessage>
							<Image
								src={process.env.PUBLIC_URL + registrationInnerExampleSrc}
								paddingBottom="1rem"
							/>
						</Paragraph>

						<Paragraph>
							<h3>
								{'2. '} <FormattedMessage id="necessaryDocuments.vehicleImages.headline" />
							</h3>
							<FormattedMessage id="necessaryDocuments.vehicleImages.description" />
							<Image
								src={`${process.env.PUBLIC_URL}/images/example-diagonal-1.jpg`}
								paddingBottom="1rem"
							/>
							<Image
								src={`${process.env.PUBLIC_URL}/images/example-diagonal-2.jpg`}
								paddingBottom="1rem"
							/>
						</Paragraph>

						<Paragraph>
							<h3>
								{'3. '}
								<FormattedMessage id="necessaryDocuments.dashboardImage.headline" />
							</h3>
							<FormattedMessage id="necessaryDocuments.dashboardImage.description" />
							<Image
								src={`${process.env.PUBLIC_URL}/images/example-dashboard-1.jpg`}
								paddingBottom="1rem"
							/>
						</Paragraph>

						<Paragraph>
							<h3>
								{'4. '}
								<FormattedMessage id="necessaryDocuments.vinImage.headline" />
							</h3>
							<FormattedMessage id="necessaryDocuments.vinImage.description" />
							<Image
								src={`${process.env.PUBLIC_URL}/images/example-vin.jpg`}
								paddingBottom="1rem"
							/>
						</Paragraph>

						<Paragraph>
							<h3>
								{'5. '}
								<FormattedMessage id="necessaryDocuments.damageImages.headline" />
							</h3>
							<FormattedMessage id="necessaryDocuments.damageImages.description" />
							<Image
								src={`${process.env.PUBLIC_URL}/images/example-damage-1.jpg`}
								paddingBottom="1rem"
							/>
							<Image
								src={`${process.env.PUBLIC_URL}/images/example-damage-2.jpg`}
								paddingBottom="1rem"
							/>
							<Image
								src={`${process.env.PUBLIC_URL}/images/example-damage-3.jpg`}
								paddingBottom="1rem"
							/>
						</Paragraph>

						<Paragraph>
							<h3>
								{'6. '}
								<FormattedMessage id="necessaryDocuments.statementImageExample.headline" />
							</h3>
							<FormattedMessage id="necessaryDocuments.statementImageExample.description" />
							<Image
								src={`${process.env.PUBLIC_URL}/images/example-statement.png`}
								paddingBottom="1rem"
							/>
						</Paragraph>

						<Paragraph>
							<h3>
								{'7. '}
								<FormattedMessage id="necessaryDocuments.bankAccountExample.headline" />
							</h3>
							<FormattedMessage id="necessaryDocuments.bankAccountExample.description" />
						</Paragraph>
					</DetailContainer>
				</DetailsContainer>
			</div>
		);
	}
}
const Image = styled.img<{ paddingBottom: string }>`
	margin-bottom: ${(p) => p.paddingBottom};
	width: 100%;
	border-radius: 3px;
`;

const Paragraph = styled.div`
	margin-bottom: 1rem;
	hyphens: auto;
	user-select: none;
	cursor: default;
`;
